import styled, { css } from 'styled-components';
import ProgressBar from './ProgressBar';
import { colorSchema } from 'utils/style';

const progressWidth = ({ percentage }) =>
  css`
    width: ${percentage}%;
  `;

export default styled(ProgressBar)`
  .progress-bar {
    display: flex;
    flex-direction: column;
    margin: 0.8rem 0;

    &__background {
      background: ${colorSchema('grey300')};
      display: block;
      position: relative;
      height: 5px;
      border-radius: 2px;
      margin-bottom: 0.4rem;
      width: 100%;
    }

    &__progress {
      background: ${colorSchema('success700')};
      border-radius: 2px;
      display: block;
      position: absolute;
      height: 5px;
      ${progressWidth}
      transition : width 1s ease;
    }

    &__label {
      color: ${colorSchema('success700')};
      font-size: 1.4rem;
    }
  }
`;
